import {
  LabelBinding,
  RequestDataOfSetSceneRequest,
  ResponseDataOfGetScenesResponse,
} from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type GetScenes = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
};
/**
 *
 *
 * @returns ResponseDataOfGetScenesResponse OK
 */
export function getScenes(
  { businessUnit, label, customerId, accountId, locationId, masterId }: GetScenes,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetScenesResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/scenes`,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}

type SetScenes = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  sceneId: string;
  requestBody: RequestDataOfSetSceneRequest;
};
/**
 *
 *
 * @returns void
 */
export function setScenes(
  { businessUnit, label, customerId, accountId, locationId, masterId, sceneId, requestBody }: SetScenes,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'PUT',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/scenes/${sceneId}`,
      body: requestBody,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}
